var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgImport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 15,
    viewBox: "0 0 11 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.41667 3.98438V0H0.6875C0.30651 0 0 0.313477 0 0.703125V14.2969C0 14.6865 0.30651 15 0.6875 15H10.3125C10.6935 15 11 14.6865 11 14.2969V4.6875H7.10417C6.72604 4.6875 6.41667 4.37109 6.41667 3.98438ZM8.13828 7.10449L6.41667 9.84375L8.13828 12.583C8.28438 12.8174 8.12109 13.125 7.84896 13.125H6.84922C6.72318 13.125 6.60573 13.0547 6.54557 12.9404C5.98411 11.8799 5.5 10.9277 5.5 10.9277C5.31667 11.3613 5.21354 11.5137 4.45156 12.9434C4.39141 13.0576 4.27682 13.1279 4.15078 13.1279H3.15104C2.87891 13.1279 2.71563 12.8203 2.86172 12.5859L4.58906 9.84668L2.86172 7.10742C2.71276 6.87305 2.87891 6.56543 3.15104 6.56543H4.14792C4.27396 6.56543 4.39141 6.63574 4.45156 6.75C5.19922 8.17969 5.02448 7.73438 5.5 8.75684C5.5 8.75684 5.67474 8.41406 6.54844 6.75C6.60859 6.63574 6.72604 6.56543 6.85208 6.56543H7.84896C8.12109 6.5625 8.28438 6.87012 8.13828 7.10449ZM11 3.57129V3.75H7.33333V0H7.50807C7.69141 0 7.86615 0.0732422 7.99505 0.205078L10.7995 3.07617C10.9284 3.20801 11 3.38672 11 3.57129Z",
    fill: "#163C68"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImport);
export default __webpack_public_path__ + "static/media/import.24e039dedcc10f9b09fe744ea8828c0a.svg";
export { ForwardRef as ReactComponent };